import { init as lazyBranchInit } from '@opportunus-lib-js/lazy-load/amp-branch-leaflet-lazy-tool.js';

lazyBranchInit();